import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect } from 'react';
import Element from 'src/components/element';
import View from 'src/components/view';

function Login() {
  const view = {};
  const crud = { changed: {}, data: {} };

  useEffect(() => {
    var idioma = navigator.language || navigator.userLanguage;

    if (idioma.startsWith('pt')) {
      (function (_w, d, u) {
        var s = d.createElement('script');
        s.async = true;
        s.src = u + '?' + ((Date.now() / 60000) | 0);

        var h = d.getElementsByTagName('script')[0];
        h.parentNode.insertBefore(s, h);
      })(window, document, 'https://cdn.bitrix24.com/b12868253/crm/site_button/loader_3_j32rz8.js');
    }
  });

  let user = {};

  let jsonUser = localStorage.getItem('user');

  if (jsonUser) {
    user = JSON.parse(jsonUser);
    window.user = user;
  }

  // Se tiver algum usuário logado, redireciona para a home
  if (user?.id) {
    window.location.href = '/home';
  }

  view.alert = function (_message, title, actions) {
    if (!actions) {
      actions = {};
    }
    if (!title) {
      title = 'Atenção';
    }
  };

  const dicionario = {
    pt: {
      cod_mundial_email: 'Cód. Mundial ou e-mail',
      senha: 'Senha',
      entrar: 'ENTRAR',
      esqueci_senha: 'Esqueci a Senha',
    },
    en: {
      cod_mundial_email: 'World Code\u00A0or\u00A0Email',
      senha: 'Password',
      entrar: 'LOGIN',
      esqueci_senha: 'Forgot Password',
    },
    es: {
      cod_mundial_email: 'Cod. Mundial o e-mail',
      senha: 'Contraseña',
      entrar: 'LOGIN',
      esqueci_senha: 'Olvidé la Contraseña',
    },
  };

  let navigatorLanguage = (navigator.language || navigator.userLanguage || 'pt').split('-')[0].toLowerCase();
  if (!dicionario[navigatorLanguage]) {
    navigatorLanguage = 'pt';
  }

  window.view = view;

  let login = {
    styleClass: 'ui-login-panel ui-login-panel-' + navigatorLanguage,
    elements: {
      left: {
        cols: 3,
        elements: {
          logo_ngs: { type: 'img', value: 'static/img/logo_ngs.png', center: true },
        },
      },
      center: {
        cols: 6,
        elements: {
          logar: {
            type: 'form',
            elements: {
              logo: { type: 'img', value: 'static/img/logo_login.png', center: true },
              username: {
                type: 'text',
                label: dicionario[navigatorLanguage].cod_mundial_email,
                translated: true,
                name: 'username',
                autoComplete: 'username',
                title: 'Informe seu login',
              },
              password: {
                type: 'password',
                label: dicionario[navigatorLanguage].senha,
                translated: true,
                name: 'password',
                autoComplete: 'current-password',
                title: 'Digite sua senha',
                enter: {
                  url: 'login',
                  store: 'user',
                  define: 'user',
                  alert: true,
                  redirect: '${user.url ? user.url : "/home" }',
                  method: 'POST',
                },
              },
              btnLogar: {
                type: 'button',
                label: dicionario[navigatorLanguage].entrar,
                translated: true,
                icon: '',
                theme: 'secondary',
                styleClass: 'ui-btn-login',
                click: {
                  url: 'login',
                  store: 'user',
                  define: 'user',
                  alert: true,
                  redirect: '${user.url ? user.url : "/home" }',
                  method: 'POST',
                },
              },
              esqueci_senha: {
                type: 'link',
                value: dicionario[navigatorLanguage].esqueci_senha,
                translated: true,
                href: 'esqueci_senha',
                center: true,
              },
            },
          },
        },
      },
      right: {
        cols: 3,
      },
    },
  };
  return (
    <View full={true}>
      <Element crud={crud} value={login} data={user} user={user} />
    </View>
  );
}

export default Login;
